// extracted by mini-css-extract-plugin
export default {"default-button":"elements_default-button__Zhzrn","default-input":"elements_default-input__vXOun","movie-catalog":"elements_movie-catalog__He1V4"};